import { notification } from "antd";
import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";
import store from "redux/store";
import history from "../history";
// import { signOut } from "redux/actions/Auth";
// import { AUTH_TOKEN, REFRESH_TOKEN } from "redux/constants/Auth";

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
});
// Config
const ENTRY_ROUTE = "/auth/login";
const TOKEN_PAYLOAD_KEY = "authorization";
const PUBLIC_REQUEST_KEY = "public-request";

// API Request interceptor
service.interceptors.request.use(
  (config) => {
    const jwtToken = store.getState().auth.token;
    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = jwtToken;
    }

    if (!jwtToken && !config.headers[PUBLIC_REQUEST_KEY]) {
      history.push(ENTRY_ROUTE);
    }
    return config;
  },
  (error) => {
    // Do something with request error here
    notification.error({
      message: "Error",
    });
    Promise.reject(error);
  },
);

// API response interceptor
service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    let notificationParam = {
      message: "",
    };
    // Remove token and redirect
    if (error.response.status === 400 || error.response.status === 403) {
      if (error.response.data && error.response.data.message) {
        notificationParam.message = error.response.data.message;
      } else {
        notificationParam.message = "Not Found";
      }
      //notificationParam.description = "Please login again";
      //localStorage.removeItem(AUTH_TOKEN)
      //history.push(ENTRY_ROUTE)
      //window.location.reload();
    }

    if (error.response.status === 401) {
      notificationParam.message =
        error.response.data.message ||
        error.response.data.error ||
        error.response.statusText ||
        "Unauthorized";

      // Dispatch signOut action to logout user
      localStorage.removeItem("persist:capmas-admin");
      // Redirect to login page
      history.push(ENTRY_ROUTE);
      window.location.reload();
    }

    if (error.response.status === 404) {
      notificationParam.message = "Not Found";
    }

    if (error.response.status === 500) {
      notificationParam.message = "Internal Server Error";
    }

    if (error.response.status === 508) {
      notificationParam.message = "Time Out";
    }

    notification.error(notificationParam);

    return Promise.reject(error);
  },
);

export default service;
